export default __webpack_public_path__ + "static/media/fullTest.9ca354bf.svg";